import React from "react";
import { connect } from "dva";
import ChatState from "@/types/chat/State";
import { message as toast } from "antd";
import { changeEgovUrl } from "@/utils/tools";
import ComNoticeCard from "@/baseComponents/ComNoticeCard";
import { FocusSDK, isFocusEnv } from "@/utils";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
import { ConferenceApplyRequest, ConferenceType } from "@/components/Voip/types";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import ImService from "@/server/ImService";
import { handleLinkClick } from "./utils";
import config, { ChatConfig } from "@/config/config";
import { AVSDK } from "@/baseComponents/Meeting/common";
import { handleCreateSingleMeeting } from "@/baseComponents/Meeting/utils";
import Employee from "@jd/jdee.im.sdk/lib/es/model/Employee";

const VoipNoticeCard = connect(function ({ chat }: { chat: ChatState }) {
  const { currentEmployee } = chat;
  return { currentEmployee };
})(function ({ message, currentEmployee }: { message: any; currentEmployee: Employee }) {
  const { title, extend = {}, infox = {} } = message;
  const { t } = useTranslation("chat");
  const deepLink = DeeplinkEvent.parseDeeplink(infox.deepLink);

  function handleCreateSingleVoip(to: any) {
    const sessionId = ImService.getInstance().generateSingleSessionId(currentEmployee, {
      app: to.appId,
      pin: to.pin,
      teamId: to.teamId
    });
    const opts: Partial<ConferenceApplyRequest> = {
      topic: t("voip.audio meeting"),
      conference_type: ConferenceType.kConferenceSingle,
      sid: sessionId,
      start: dayjs().valueOf()
    };
    FocusSDK.sendIpcMessage("voip:createSingleCall", {
      request: opts,
      invite: {
        member_app_: to.appId,
        member_id_: to.pin,
        team_id_: to.teamId
      }
    });
  }

  function handleClick() {
    if (infox.action === "joinmeeting" && deepLink?.mparam?.fromUser) {
      if (infox.type === "jrtcVoice") {
        const fromUser = deepLink.mparam?.fromUser;
        handleCreateSingleMeeting({
          from: {
            pin: currentEmployee.userId,
            teamId: currentEmployee.teamId,
            avatar: currentEmployee.avatar,
            app: currentEmployee.app,
            name: currentEmployee.name
          },
          to: {
            app: fromUser.app || "",
            name: fromUser.name || "",
            pin: fromUser.pin || "",
            teamId: fromUser.teamId || "",
            avatar: fromUser.avatar || ""
          },
          avsdk: AVSDK.JBRTC,
          type: "voice"
        }).catch((e) => {
          console.error(e);
          toast.error(e?.message || e || "创建会议失败");
        });
      } else {
        handleCreateSingleVoip(deepLink.mparam.fromUser);
      }
    } else if (extend.url) {
      handleLinkClick(extend.url);
    } else {
      toast.warn("当前版本暂不支持，请升级至最新版本");
    }
  }
  function loadButtons() {
    if (!isFocusEnv() || !config[ChatConfig.CHAT_SESSION_CREATE_VOIP_ENABLE]) {
      return null;
    }
    if (infox.btnName) {
      return (
        <div onClick={handleClick} className="button_item">
          {infox.btnName}
        </div>
      );
    }
    return null;
  }

  return (
    <ComNoticeCard
      message={message}
      avatarSrc={changeEgovUrl(message.sender.avatar)}
      type={extend.applicationName}
      contentList={extend.fields}
      title={title}
      loadButtonsFn={loadButtons}
    />
  );
});

export default VoipNoticeCard;
